/** A Calendar Item */
export interface CalendarItem {
  start: Date;
}

/** Has an end date */
export interface HasEndDate {
  end: Date;
}

export interface CalendarItemTag {
  name: string;
  displayName: string;
  data?: any;
}

export interface SupportWorkerEventTag extends CalendarItemTag {
  data: {
    check_in_timestamp?: string;
    check_out_timestamp?: string;
    last_seen_timestamp?: string;
    support_worker_name?: string;
  };
}

// Add more known tags as needed to both the type (using union) and to the AVAILABLE_TAGS record
type KnownTag = SupportWorkerEventTag;
export const AVAILABLE_TAGS: Record<
  KnownTag['name'],
  Pick<KnownTag, 'name' | 'displayName'>
> = {
  support_worker: {
    name: 'support_worker',
    displayName: 'Support Worker Event',
  },
} as const;

export type TagsObject = Partial<Record<string, CalendarItemTag>>;
